import { render, staticRenderFns } from "./AttendanceChange.vue?vue&type=template&id=97419ca0"
import script from "./AttendanceChange.vue?vue&type=script&lang=js"
export * from "./AttendanceChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports